type SelectorOption = {
    value: string;
    label: string;
}

export type SelectorData = SelectorOption[];

export const ageSelectorOptions: SelectorData = [
    // {value: "1", label: "12-24 თვის"},
    // {value: "1.25", label: "15-17 თვის"},
    // {value: "1.5", label: "18-20 თვის"},
    // {value: "1.75", label: "21-23 თვის"},
    // {value: "2", label: "2 წლის"},
    // {value: "3", label: "3 წლის"},
    {value: "4", label: "4 წლის"},
    {value: "5", label: "5 წლის"},
    {value: "6", label: "6 წლის"},
    {value: "7", label: "7 წლის"},
    {value: "8", label: "8 წლის"},
    {value: "9", label: "9 წლის"},
    {value: "10", label: "10 წლის"},
    {value: "11", label: "11 წლის"},
    {value: "12", label: "12 წლის"},
    {value: "13", label: "13 წლის"},
    {value: "14", label: "14 წლის"},
    {value: "15", label: "15 წლის"},
    {value: "16", label: "16 წლის"},
    {value: "17", label: "17 წლის"},
    {value: "18", label: "18 წლის"},
    {value: "19", label: "19 წლის"},
    {value: "20", label: "20 წლის"},
    {value: "21", label: "21 წლის"},
    {value: "22", label: "22 წლის"},
    {value: "23", label: "23 წლის"},
    {value: "24", label: "24 წლის"},
    {value: "25", label: "25 წლის"},
    {value: "26", label: "26 წლის"},
    {value: "27", label: "27 წლის"},
    {value: "28", label: "28 წლის"},
    {value: "29", label: "29 წლის"},
    {value: "30", label: "30 წლის"},
    {value: "31", label: "31 წლის"},
    {value: "32", label: "32 წლის"},
    {value: "33", label: "33 წლის"},
    {value: "34", label: "34 წლის"},
    {value: "35", label: "35 წლის"},
    {value: "36", label: "36 წლის"},
    {value: "37", label: "37 წლის"},
    {value: "38", label: "38 წლის"},
    {value: "39", label: "39 წლის"},
    {value: "40", label: "40 წლის"},
    {value: "41", label: "41 წლის"},
    {value: "42", label: "42 წლის"},
    {value: "43", label: "43 წლის"},
    {value: "44", label: "44 წლის"},
    {value: "45", label: "45 წლის"},
    {value: "46", label: "46 წლის"},
    {value: "47", label: "47 წლის"},
    {value: "48", label: "48 წლის"},
    {value: "49", label: "49 წლის"},
    {value: "50", label: "50 წლის"},
    {value: "51", label: "51 წლის"},
    {value: "52", label: "52 წლის"},
    {value: "53", label: "53 წლის"},
    {value: "54", label: "54 წლის"},
    {value: "55", label: "55 წლის"},
    {value: "56", label: "56 წლის"},
    {value: "57", label: "57 წლის"},
    {value: "58", label: "58 წლის"},
    {value: "59", label: "59 წლის"},
    {value: "60", label: "60 წლის"},
    {value: "61", label: "61 წლის"},
    {value: "62", label: "62 წლის"},
    {value: "63", label: "63 წლის"},
    {value: "64", label: "64 წლის"},
    {value: "65", label: "65 წლის"},
    {value: "66", label: "66 წლის"},
    {value: "67", label: "67 წლის"},
    {value: "68", label: "68 წლის"},
    {value: "69", label: "69 წლის"},
    {value: "70", label: "70 წლის"},
    {value: "71", label: "71 წლის"},
    {value: "72", label: "72 წლის"},
    {value: "73", label: "73 წლის"},
    {value: "74", label: "74 წლის"},
    {value: "75", label: "75 წლის"},
    {value: "76", label: "76 წლის"},
    {value: "77", label: "77 წლის"},
    {value: "78", label: "78 წლის"},
    {value: "79", label: "79 წლის"},
    {value: "80", label: "80 წლის"},
    {value: "81", label: "81 წლის"},
    {value: "82", label: "82 წლის"},
    {value: "83", label: "83 წლის"},
    {value: "84", label: "84 წლის"},
    {value: "85", label: "85 წლის"},
    {value: "86", label: "86 წლის"},
    {value: "87", label: "87 წლის"},
    {value: "88", label: "88 წლის"},
    {value: "89", label: "89 წლის"},
    {value: "90", label: "90 წლის"},
    {value: "91", label: "91 წლის"},
    {value: "92", label: "92 წლის"},
    {value: "93", label: "93 წლის"},
    {value: "94", label: "94 წლის"},
    {value: "95", label: "95 წლის"},
    {value: "96", label: "96 წლის"},
    {value: "97", label: "97 წლის"},
    {value: "98", label: "98 წლის"},
    {value: "99", label: "99 წლის"},
];

export const sexSelectorOptions: SelectorData = [
    {value: "male", label: "მამრობითი"},
    {value: "female", label: "მდედრობითი"}
]

export const pregnancyBreastfeedingSelectorOptions: SelectorData = [
    {value: "pregnant", label: "ორსული"},
    {value: "breastfeeding", label: "მეძუძური"},
    {value: "none", label: "არცერთი"},
]

export const trimesterSelectorOptions: SelectorData = [
    {value: "1", label: "პირველი ტრიმესტრი"},
    {value: "2", label: "მეორე ტრიმესტრი"},
    {value: "3", label: "მესამე ტრიმესტრი"},
]

export const breastfeedingAmountSelectorOptions: SelectorData = [
    {value: "all", label: "მხოლოდ ბუნებრივი კვება, არანაირი დანამატი"},
    {value: "half", label: "ნახევრად ბუნებრივი კვება & შესაბამისი რაოდენობის დანამატი"},
    {value: "some", label: "მცირე დოზით ბუნებრივი, ძირითადად ხელოვნური კვება"}
]

export const breastfeedingTimeSelectorOptions: SelectorData = [
    {value: "0-6", label: "0-6 თვე"},
    {value: "6<", label: "6 თვეზე მეტი"}
]

export const activitySelectorOptions: SelectorData = [
    {value: "low", label: "30 წუთზე ნაკლები ზომიერი აქტივობა"},
    {value: "mid", label: "30-დან 60 წუთამდე ზომიერი აქტივობა"},
    {value: "high", label: "60 წუთზე მეტი ზომიერი აქტივობა"}
]